/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_Preferences_TitleInputs */

const en_notification_preferences_title = /** @type {(inputs: Notification_Preferences_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification preferences`)
};

/**
* | output |
* | --- |
* | "Notification preferences" |
*
* @param {Notification_Preferences_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const notification_preferences_title = /** @type {((inputs?: Notification_Preferences_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Preferences_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notification_preferences_title(inputs)
});